import React from 'react';
import { inject, observer } from 'mobx-react';
import VirtualizedList from '../common/VirtualizedList';
import { Segment, Header } from 'semantic-ui-react';

export default inject('store')(observer(props => {
  const { items, onClickItem } = props
  const rowRenderer = ({ index, key, parent, style }) => {
    const material = items[index]
    return(
      <Segment vertical
        key={key}
        onClick={event => onClickItem({ 
          event: event,
          index: index,
          rowData: material 
        })} 
        style={style}
      >
        <Header size='small'>{material.description}</Header>
        {material.costAsStringWithDimensions}
      </Segment>
    )
  }
  return <VirtualizedList
    rowHeight={62}
    rowRenderer={rowRenderer}
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/materials/MaterialList.js